// extracted by mini-css-extract-plugin
export default {"favAdded":"favorite_favAdded__n+0L9","favNotAdded":"favorite_favNotAdded__WLulw","card":"favorite_card__ocwjE"};